module.exports = __WEBPACK_EXTERNAL_MODULE_17__;


//////////////////
// WEBPACK FOOTER
// external {"root":"jspdf","commonjs2":"jspdf","commonjs":"jspdf","amd":"jspdf"}
// module id = 17
// module chunks = 0